/* eslint-disable @typescript-eslint/no-magic-numbers */
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { SliderInputComponent } from '../../shared/components/slider-input/slider-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { map, Observable, Subject, Subscription } from 'rxjs';
import { PopsyInputComponent } from '../inputs/input/popsy-input.component';
import { PriceModel } from '@app/shared/models/api/price.model';
import { AmountPipe } from '@app/shared/pipes/amount.pipe';
import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { ScreenSizeInfoState } from '@app/akita/screen/state/screen.store';
import { TranslocoModule } from '@ngneat/transloco';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { Direction } from '@angular/cdk/bidi';

@Component({
  selector: 'app-installments-calculator',
  templateUrl: './installments-calculator.template.html',
  styleUrls: ['./installments-calculator.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    A11yModule,
    SliderInputComponent,
    AmountPipe,
    TranslocoModule,
    PopsyInputComponent,
  ],
})
export class InstallmentsCalculatorComponent implements OnDestroy {
  @Input() public amount?: number | null = null;
  @Input() public currency?: string | null = null;
  @Input() public source?: string | null = null;
  @Input() public minValue?: number | null = 1;
  @Input() public maxValue?: number | null = 15000;
  @Input() public maxInstallments?: number | null = 4;
  @Input() public minInstallments?: number | null = 1;

  public biggerThan$: Observable<ScreenSizeInfoState>;
  public direction$: Observable<Direction>;

  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  public installments = 4;

  @Output() public readonly valueChange: EventEmitter<boolean>;

  private readonly subscriptions: Subscription = new Subscription();
  private readonly destroySubject: Subject<void> = new Subject();

  constructor(
    private readonly changeDetector: ChangeDetectorRef,
    private readonly akitaScreenQuery: AkitaScreenQuery,
    private readonly akitaRouterQuery: AkitaRouterQuery
  ) {
    this.biggerThan$ = this.akitaScreenQuery.selectBiggerThan();
    this.direction$ = this.akitaRouterQuery
      .selectIsRtlLayout()
      .pipe(map((isRtl) => (isRtl ? 'rtl' : 'ltr')));
    this.valueChange = new EventEmitter();
  }

  public onChange(): boolean {
    return false;
  }

  public onAmountChange($event: any): void {
    if ($event.max) {
      this.amount = Number($event.max.amount);
    } else {
      this.amount = Number($event);
    }
    this.changeDetector.detectChanges();
    this.changeDetector.markForCheck();
  }

  public onInstallmentsChange($event: any): void {
    console.log('event', $event);
    if ($event.max) {
      this.installments = Number($event.max.amount);
    } else {
      this.installments = Number($event);
    }
    this.changeDetector.detectChanges();
    this.changeDetector.markForCheck();
  }

  public calculatedInstallment(): PriceModel {
    const installment = new PriceModel();
    if (this.installments && this.amount) {
      installment.amount = this.amount / this.installments;
      installment.currency = this.currency || 'USD';
    }

    console.log('installment', installment);
    return installment;
  }

  public calculatedDownpayment(): PriceModel {
    const installment = new PriceModel();
    if (this.installments === 1) {
      installment.amount = 0;
    } else {
      installment.amount = (this.amount || 0) / (this.installments || 1);
    }
    installment.currency = this.currency || 'USD';
    return installment;
  }
  public calculatedTotal(): PriceModel {
    const total = new PriceModel();
    total.amount = this.amount || 0;
    total.currency = this.currency || 'USD';
    return total;
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.destroySubject.next();
    this.destroySubject.complete();
  }
}
